import * as React from 'react';
import { open, authenticate, authenticateEmailRequired, authenticateEmailTaken, authenticateError } from '../../../actions/social';
import { emit } from '../../../actions/events';
import { ESocialResponseType } from '../../../types/social';
import { EEventType } from '../../../types/events';
import { trackSocialButtonClick } from '../../../utils/tracking';
/* TODO переписать это всё */
export function useDeprecatedSocialCallback(useDispatch, source) {
  var dispatch = useDispatch();
  var handleSocialSuccess = function handleSocialSuccess(type) {
    return function (socialLoginId, email, token, userCreated) {
      dispatch(authenticate({
        socialType: type,
        socialLoginId: socialLoginId,
        email: email,
        token: token,
        userCreated: userCreated,
        source: source
      }));
    };
  };
  var handleSocialEmailRequired = function handleSocialEmailRequired(socialType, socialLoginId) {
    dispatch(authenticateEmailRequired({
      socialLoginId: socialLoginId,
      socialType: socialType,
      email: '',
      phone: ''
    }));
  };
  var handleSocialEmailTaken = function handleSocialEmailTaken(email, socialLoginId, socialType) {
    dispatch(authenticateEmailTaken({
      email: email,
      socialLoginId: socialLoginId,
      socialType: socialType
    }));
  };
  var handleSocialError = function handleSocialError(type) {
    return function () {
      dispatch(authenticateError(type));
    };
  };
  var handleSocialResponse = function handleSocialResponse() {
    for (var _len = arguments.length, response = new Array(_len), _key = 0; _key < _len; _key++) {
      response[_key] = arguments[_key];
    }
    var type = response[0],
      data = response[1];
    switch (type) {
      case ESocialResponseType.UserNotFound:
        {
          var socialLoginId = data.socialLoginId,
            socialType = data.socialType,
            email = data.email,
            phone = data.phone;
          dispatch(authenticateEmailRequired({
            socialLoginId: socialLoginId,
            socialType: socialType,
            email: email,
            phone: phone
          }));
          break;
        }
    }
  };
  var handleSocialClick = React.useCallback(function (socialType) {
    window._socialResponse = handleSocialResponse;

    /* DEPRECATED */
    window.socialLogOnStart = handleSocialSuccess(socialType);
    window.showNeedEmailPopup = handleSocialEmailRequired;
    window.showNeedMergeEmailPopup = handleSocialEmailTaken;
    window.showErrorSocialAuth = handleSocialError(socialType);
    dispatch(emit(EEventType.SocialButtonClick, {
      type: socialType
    }));
    dispatch(open({
      socialType: socialType
    }));
    trackSocialButtonClick(socialType, source);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return handleSocialClick;
}